import { useState } from "react";
import AdminCashMonitorService from "../../services/cash/AdminCashMonitorService";
import { AdminCashRegisterMonitorDTO } from "../../types/cash/adminCashMonitor";
import useApiErrorHandler from "../useApiErrorHandler";

export const useAdminCashMonitor = () => {
  const { handle } = useApiErrorHandler();

  const [registers, setRegisters] = useState<AdminCashRegisterMonitorDTO[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchRegistersByBranch = async (branchId: number) => {
    try {
      setLoading(true);
      const data = await AdminCashMonitorService.getRegistersByBranch(branchId);
      setRegisters(data);
      return data;
    } catch (error) {
      handle(error);
      setRegisters([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const clear = () => setRegisters([]);

  return {
    registers,
    loading,
    fetchRegistersByBranch,
    clear,
  };
};
